import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './QtrBookOfBusinessRow.module.css';
import headerStyles from './QtrBookOfBusinessRowHeader.module.css';

interface QtrBookOfBusinessRowHeaderProps {
  readonly helmet: {
    label?: string;
    hasBenchmarkAnalysis?: boolean;
  };
  /** Whether to include Loss Ratio column labels (LOB layout vs States layout) */
  readonly includeLossRatio?: boolean;
  /** Label for losses column - "Losses Paid" for States, "Losses Incurred" for LOB */
  readonly lossesLabel?: string;
}

export default function QtrBookOfBusinessRowHeader({
  helmet,
  includeLossRatio = false,
  lossesLabel = 'Losses Paid'
}: QtrBookOfBusinessRowHeaderProps) {
  const { showBenchmark } = useContext(AppContext);
  const collapseClass = showBenchmark ? '' : `${styles.collapse} ${headerStyles.collapse}`;

  return (
    <div className={headerStyles.headerWrapper} data-testid="qtr-book-of-business-row-header">
      {/* Top Row: Group headers ("CYTD Book of Business" / "PYTD Book of Business") */}
      <div className={`${styles.container} ${collapseClass} ${headerStyles.topRow}`}>
        <h5 className={`${headerStyles.groupHeader} ${headerStyles.cytdGroup}`}>
          CYTD Book of Business
        </h5>
        <h5 className={`${headerStyles.groupHeader} ${headerStyles.pytdGroup}`}>
          PYTD Book of Business
        </h5>
      </div>

      {/* Bottom Row: Column labels */}
      <div className={`${styles.container} ${collapseClass} ${headerStyles.bottomRow}`}>
        <h5 className={headerStyles.textLeft}>{helmet.label}</h5>
        <h5 aria-hidden="true"></h5>
        <h5 aria-hidden="true"></h5>
        <h5 className={headerStyles.columnAlignCenter} aria-hidden={!helmet.hasBenchmarkAnalysis}>
          {showBenchmark && helmet.hasBenchmarkAnalysis ? 'Benchmark' : ''}
        </h5>
        <h5 className="column_align_right">Premium % Change</h5>
        <h5 className="column_align_right">Premium</h5>
        <h5 className="column_align_right">% of Total</h5>
        <h5 className="column_align_right">{lossesLabel}</h5>
        <h5 className="column_align_right" aria-hidden={!includeLossRatio}>
          {includeLossRatio ? 'Loss Ratio' : ''}
        </h5>
        <h5 className="column_align_right">Premium</h5>
        <h5 className="column_align_right">% of Total</h5>
        <h5 className="column_align_right">{lossesLabel}</h5>
        <h5 className="column_align_right" aria-hidden={!includeLossRatio}>
          {includeLossRatio ? 'Loss Ratio' : ''}
        </h5>
      </div>
    </div>
  );
}
